import { render, staticRenderFns } from "./addAStaffCommunity.vue?vue&type=template&id=e8de84a6"
import script from "./addAStaffCommunity.vue?vue&type=script&lang=js"
export * from "./addAStaffCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports